import { Injectable } from '@angular/core';

@Injectable()
export class ConvertTimeExpressionService {
  private bonusesMode: Array<string> = ['SINGLE_DAYS', 'CONTINUOUS_DAYS', 'DATE_EXPRESSION'];

  constructor() {}

  getBonuseMode() {
    return this.bonusesMode;
  }

  getConvertedExpression(expression: Array<string>) {
    if (!expression) {
      return {
        bonusesMode: 'CONTINUOUS_DAYS',
        start_day: 0,
        end_day: 6,
        start_time: '00:00',
        end_time: '23:59'
      };
    }
    const res = {
      ...this.expressionDateModeSource(expression),
      ...this.expressionContinuousDaysSource(expression),
      ...this.expressionSingleDaysSource(expression)
    };
    return res;
  }

  private expressionDateModeSource(expression) {
    if (expression.length === 1 && expression[0].indexOf('=') + 1) {
      const dateExpressionArray = [...expression[0].match('=z{(.*)};z{(.*)}=')].slice(-2);
      return {
        bonuses_mode: this.bonusesMode[2],
        start_time: dateExpressionArray[0].slice(-9, -4),
        end_time: dateExpressionArray[1].slice(-9, -4),
        start_date: new Date(dateExpressionArray[0].substring(0, 10)),
        end_date: new Date(dateExpressionArray[1].substring(0, 10))
      };
    }
  }

  private expressionContinuousDaysSource(expression) {
    if (expression.length === 3) {
      const startDateArray = [...expression[0].match('~w{(.*)};t{(.*)}~')].slice(-2);
      const endDateArray = [...expression[2].match('~w{(.*)};t{(.*)}~')].slice(-2);
      return {
        bonuses_mode: this.bonusesMode[1],
        start_time: startDateArray[1].slice(0, 5),
        end_time: endDateArray[1].slice(6, 11),
        start_day: parseInt(startDateArray[0]),
        end_day: parseInt(endDateArray[0])
      };
    }
  }

  private expressionSingleDaysSource(expression) {
    let resultObj;
    if (expression.length === 1 && expression[0].indexOf('~w{') + 1) {
      resultObj = this.getFirstHalfOfDayExpression(expression[0]);
    }
    if (expression.length === 2) {
      resultObj = this.getSecondHalfOfDayExpression(expression);
    }
    return resultObj;
  }

  private getFirstHalfOfDayExpression(expression) {
    const timeArray = expression.match('~w{(.*)};t{(.*)}~').slice(-2);
    return {
      bonuses_mode: this.bonusesMode[0],
      start_time: timeArray[1].slice(0, 5),
      end_time: timeArray[1].slice(-5),
      days_of_week: this.getDaysOfWeek(timeArray[0])
    };
  }

  private getSecondHalfOfDayExpression(expression) {
    const startTimeValue = expression[0].match('~w{(.*)};t{(.*)}~').slice(-2);
    const endTimeValue = expression[1].match('~w{(.*)};t{(.*)}~').slice(-2);
    let resObj = {};
    if (endTimeValue[0] - startTimeValue[0] === 1) {
      resObj = {
        bonuses_mode: this.bonusesMode[1],
        start_day: parseInt(startTimeValue[0]),
        end_day: parseInt(endTimeValue[0])
      };
    } else {
      resObj = {
        bonuses_mode: this.bonusesMode[0],
        days_of_week: this.getDaysOfWeek(startTimeValue[0])
      };
    }
    return {
      start_time: startTimeValue[1].slice(0, 5),
      end_time: endTimeValue[1].slice(6, 11),
      ...resObj
    };
  }

  private getDaysOfWeek(daysOfWeek: string) {
    const resultArr = daysOfWeek.split(',').map(el => {
      if (el.indexOf('-') !== -1) {
        return this.splitWeeksArraySource(el);
      } else {
        return [Number(el)];
      }
    });
    return [].concat.apply([], resultArr);
  }

  private splitWeeksArraySource(el) {
    const arr = el.split('-');
    const result = [];
    for (let i = Number(arr[0]); i <= Number(arr[1]); i++) {
      result.push(i);
    }
    return result;
  }

  getFormAnObjectToSend(obj) {
    let resultObj = Object.create({});
    switch (obj.bonuses_mode) {
      case this.bonusesMode[0]:
        resultObj = { ...this.daysModeObjectSorce(obj) };
        break;
      case this.bonusesMode[1]:
        resultObj = { ...this.continuousDaysConvertToObjectSource(obj) };
        break;
      case this.bonusesMode[2]:
        resultObj = { ...this.dateConvertToObjectSource(obj) };
        break;
      default:
        this.daysModeObjectSorce(obj);
        break;
    }
    return resultObj;
  }

  private daysModeObjectSorce(obj) {
    let resultExpressionArray = ' ';
    // if (obj.start_time < obj.end_time) {
    resultExpressionArray = `[\"~w{${obj.days_of_week.join(',')}};t{${obj.start_time}-${obj.end_time}}~\"]`;
    //   } else  resultExpressionArray = `[\"~w{${obj.days_of_week.join(',')}};t{${obj.start_time}-23:59}~\", \"~w{${obj.days_of_week.join(',')}};t{00:00-${obj.end_time}}~\"]`;
    return {
      expression: resultExpressionArray
    };
  }

  private continuousDaysConvertToObjectSource(obj) {
    const startDay = obj.start_day,
      endDay = obj.end_day,
      daysInterval = [0, 1, 2, 3, 4, 5, 6];
    let res = [];
    if (startDay < endDay) {
      res = daysInterval.slice(startDay + 1, endDay);
    }
    if (startDay > endDay) {
      res = [...daysInterval.splice(startDay + 1, daysInterval.length - 1), ...daysInterval.splice(0, endDay)];
    }
    if (startDay === endDay) {
      res = [];
    }
    return {
      expression: `[\"~w{${startDay}};t{${obj.start_time}-23:59}~\", ${
        res.length ? `\"~w{${res.join(',')}};t{00:00-23:59}~\",` : ''
      }\"~w{${endDay}};t{00:00-${obj.end_time}}~\"]`
    };
  }

  private dateConvertToObjectSource(obj) {
    const startDate = obj.start_date
      .toLocaleString()
      .slice(0, 10)
      .split('.')
      .reverse()
      .join('-');
    const endDate = obj.end_date
      .toLocaleString()
      .slice(0, 10)
      .split('.')
      .reverse()
      .join('-');
    return {
      expression: JSON.stringify([`=z{${startDate}T${obj.start_time}:00Z};z{${endDate}T${obj.end_time}:00Z}=`])
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/convert-time-expression.service.ts